import { waitForElem } from "../../utils/wait_for_elem"

/* Print button for templates/global/share_buttons.html */
waitForElem('.scroll-to-top').then((elems: NodeListOf<Element>) => {
  elems.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  })
})
